import Manager from 'components/organisms/Manager';
import { GalleryContext } from 'context/gallery/GalleryContext';
import React, { useContext, useEffect } from 'react';

const HomepageTemplate = () => {
    const { state, setGalleryState } = useContext(GalleryContext);

    useEffect(() => {
        setGalleryState({ ...state, isUploading: false });
    }, []);
    return <Manager />;
};

export default HomepageTemplate;
